var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('el-row',[(_vm.pageData)?_c('el-col',{staticClass:"padding-right-xs"},[_c('l-table',{attrs:{"option":_vm.tableOption,"data":_vm.pageData.list,"start-index":_vm.pageData.startIndex}}),_c('l-pager',{attrs:{"page":_vm.pageData},on:{"change":_vm.getPageData}})],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }